export default __webpack_public_path__ + "cad05fdd2c698ce9e94f4db0c52ecdd5.png";